import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { Grid, Icon, Tooltip, IconButton } from '@material-ui/core';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom'
import { bindActionCreators } from 'redux';
import ReactTable from "react-table";
import * as Actions from './store/actions'
import SelfPacedCourseAddDialog from './SelfPacedCourseAddDialog';
import moment from 'moment';
import TableCellTooltip from '../../components/TableCellTooltip';
import TabPanelButtons from '../../components/TabPanelButtons';
import * as HelperFunctions from '../../components/helpers'; 

const styles = theme => ({

});

class SelfPacedCourses extends Component {

    constructor(props) {
        super(props);
        const company_id = this.props.company_id;

        this.props.getUnscheduledCourses(company_id)
    }

    state = {
        activeRow: {
            company_calendar_course_id: 0,
            course_id: 0,
            start: null,
            end: null,
            introCourse: 0
        }
    }

    handleApply = () => {
        this.setState({
            activeRow: {
                company_calendar_course_id: 0,
                course_id: 0,
                start: null,
                end: null,
                introCourse: 0
            }
        })
        this.props.toggleUnscheduledAddDialog(true)
    }

    timeColumn = (timeValue) => {
        if (timeValue) {
            return moment(timeValue).format('YYYY-MM-DD')
        }
        else {
            return null
        }
    }

    render() {

        const { classes, company_id, view_type } = this.props
        // console.log('self', view_type);
        return (
            <Grid container spacing={8}>
                <SelfPacedCourseAddDialog open={this.props.addUnscheduledDialog} company_id={company_id} course={this.state.activeRow} />
                    <div className="px-24 flex flex-1 justify-end">
                        <TabPanelButtons
                            component_name = {"course"}
                            view_type      = {view_type}
                            button_list    = {[
                                {
                                    display: "Add",
                                    type:    "create",
                                    color:   "primary",
                                    onClick: () => this.handleApply()
                                }
                            ]}
                        />
                    </div>
                <Grid item xs={12}>
                    <ReactTable
                        columns={[
                            {
                                Header: "Course Name",
                                // accessor: "CourseName"
                                Cell: row => (
                                    <TableCellTooltip 
                                        item={row.original.CourseName}
                                        chars={20}
                                    />
                                )
                            },
                            {
                                Header: "Start Date",
                                accessor: a => this.timeColumn(a.StartDate),
                                id: 'StartDate'
                            },
                            {
                                Header: "End Date",
                                accessor: a => this.timeColumn(a.EndDate),
                                id:'EndDate' 
                            },
                            {
                                Header: "Action",
                                Cell: row => (
                                    <div className="flex items-center">
                                        {!HelperFunctions.checkPermission(this.props.auth.user.data.permissionList, "scheduled_course", "edit") || view_type === 'detail' ? null :
                                            <Tooltip title="Edit">
                                                <IconButton
                                                    style={{ padding: '0px', marginLeft: '5px', marginRight: '5px' }}
                                                    onClick={(ev) => {
                                                        ev.stopPropagation();
                                                        this.setState({
                                                            activeRow: {
                                                                company_calendar_course_id: row.original.company_calendar_course_id,
                                                                start: moment(row.original.StartDate),
                                                                end: moment(row.original.EndDate),
                                                                // start: row.original.StartDate,
                                                                // end: row.original.EndDate,
                                                                course_id: row.original.course_id,
                                                                introCourse: row.original.introCourse
                                                            }
                                                        })
                                                        this.props.toggleUnscheduledAddDialog(true)
                                                    }}
                                                >
                                                    <Icon>border_color</Icon>
                                                </IconButton>
                                            </Tooltip>
                                        }
                                        {!HelperFunctions.checkPermission(this.props.auth.user.data.permissionList, "scheduled_course", "delete") || view_type === 'detail' ? null :
                                            <Tooltip title="Delete">
                                                <IconButton
                                                    style={{ padding: '0px', marginLeft: '5px', marginRight: '5px' }}
                                                    onClick={(ev) => {
                                                        ev.stopPropagation();
                                                        this.props.deleteCourse(this.props.company_id, row.original.company_calendar_course_id, null, true)
                                                    }}
                                                >
                                                    <Icon>delete</Icon>
                                                </IconButton>
                                            </Tooltip>
                                        }
                                    </div>
                                )
                            }

                        ]}
                        data={this.props.unscheduledCourses}
                        defaultPageSize={25}
                        className="-striped -highlight"
                        noDataText="No Courses Found"
                    />
                </Grid>
            </Grid>
        )
    }
}


function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        toggleUnscheduledAddDialog: Actions.toggleUnscheduledAddDialog,
        getUnscheduledCourses: Actions.getUnscheduledCourses,
        deleteCourse: Actions.deleteCourseFromSchedule
    }, dispatch)
}

function mapStateToProps({ auth, companyApp }) {
    return {
        auth,
        addUnscheduledDialog: companyApp.companies.addUnscheduledDialog,
        unscheduledCourses: companyApp.companies.unscheduledCourses
    }
}

export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(SelfPacedCourses)));


// WEBPACK FOOTER //
// src/main/content/company/SelfPacedCourses.js